import { useEffect, useState } from "react";
import { api } from "../api/client.ts";
import type { Overview } from "../api/types.ts";

export type AssetInfo = { asset: string; chain: string; token: string; decimals: number };
let cache: Promise<AssetInfo[]> | null = null;
/** Forget the list (another brand became active). */
export const resetAssetCache = () => {
  cache = null;
};

/** The merchant's assets (enabled networks, from the overview) for filter dropdowns. Cached for the tab. */
export function useAssets(): AssetInfo[] {
  return useAssetList().assets;
}

/** Same, plus whether the list has loaded (an empty list then means no network is enabled yet). */
export function useAssetList(): { assets: AssetInfo[]; loaded: boolean } {
  const [state, setState] = useState<{ assets: AssetInfo[]; loaded: boolean }>({ assets: [], loaded: false });
  useEffect(() => {
    cache ??= api
      .get<Overview>("/overview")
      .then((o) => o.balances.map(({ asset, chain, token, decimals }) => ({ asset, chain, token, decimals })))
      .catch((e) => {
        cache = null;
        throw e;
      });
    let alive = true;
    cache.then((a) => alive && setState({ assets: a, loaded: true })).catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  return state;
}
